import { Typography } from '@mui/material';
import styles from './TextAnswer.styles';

type TextAnswerComponentProps = {
  answer: string;
};

const TextAnswerComponent = function ({ answer }: TextAnswerComponentProps): JSX.Element {
  return (
    <Typography sx={styles} data-testid="question-response">
      {answer}
    </Typography>
  );
};

export default TextAnswerComponent;
